import React from 'react';
import { useBreakpoint } from '@landr/maestro';
import { _Slide } from './Slide';

const SlideSkeleton = () => {
    const isVertical = useBreakpoint('md');

    return (
        <_Slide
            isVertical={isVertical}
            isLoading={true}
            artworks={undefined}
            details={undefined}
            backgroundColor={undefined}
            foregroundColor="white"
        />
    );
};

export default SlideSkeleton;
